// Valor de una línea de la orden, con la misma regla del backend
// (backend/src/utils/orderLine.js): un surtido que se cobra por tallo vale la
// suma de sus componentes, cada uno a su precio, sumada en centavos enteros.
// Por RAMO o CAJA, o sin componentes, se cobra la unidad como siempre. Nunca
// se calcula un precio promedio.

const toCents = (amount) => Math.round(Number(amount) * 100);

export const hasOwnPrice = (component) =>
  component.unit_price !== null && component.unit_price !== undefined && component.unit_price !== '';

// Por tallo cada componente guarda su precio. Solo los surtidos guardados antes
// de eso tienen componentes sin precio: se resuelven con el de la línea.
export const resolveComponentPrice = (component, linePrice) =>
  hasOwnPrice(component) ? Number(component.unit_price) : Number(linePrice) || 0;

const stemsPerBox = (component) => (Number(component.bunches) || 0) * (Number(component.stems_per_bunch) || 0);

const componentCents = (component, linePrice, boxes) =>
  boxes * stemsPerBox(component) * toCents(resolveComponentPrice(component, linePrice));

// Valor de un componente en `boxes` cajas (una, por defecto).
export const componentValue = (component, linePrice, boxes = 1) =>
  componentCents(component, linePrice, boxes) / 100;

// Valor de una caja del surtido.
export const assortmentValuePerBox = (components, linePrice) =>
  (components || []).reduce((acc, c) => acc + componentCents(c, linePrice, 1), 0) / 100;

// `line` trae billing_unit, unit_price, quantity y los totales de la línea.
export const lineSubtotal = (line, components = []) => {
  const price = Number(line.unit_price) || 0;

  if (line.billing_unit === 'TALLO' && components.length > 0) {
    const boxes = Number(line.quantity) || 0;
    return components.reduce((acc, c) => acc + componentCents(c, price, boxes), 0) / 100;
  }

  if (line.billing_unit === 'TALLO') return (Number(line.total_stems) || 0) * price;
  if (line.billing_unit === 'RAMO') return (Number(line.total_bunches) || 0) * price;
  if (line.billing_unit === 'CAJA') return (Number(line.total_boxes) || 0) * price;
  return 0;
};

// Si los componentes no comparten un mismo precio: es cuando se muestra "Múltiples".
export const hasMultipleComponentPrices = (components, linePrice) =>
  new Set((components || []).map((c) => toCents(resolveComponentPrice(c, linePrice)))).size > 1;

// Al abrir un surtido guardado antes del precio por componente, sus
// componentes sin precio toman el de la línea, que es con el que se cobraban.
export const fillMissingPrices = (components, linePrice) =>
  (components || []).map((c) => (hasOwnPrice(c) ? c : { ...c, unit_price: Number(linePrice) || 0 }));

// Precio de una línea por tallo con surtido: el que cubre más tallos de la
// caja, sumando los componentes que comparten precio. En empate gana el que
// aparece primero. Nunca se promedia. null si ningún componente tiene precio.
export const resolveBasePrice = (components) => {
  const stemsByPrice = new Map();
  (components || []).filter(hasOwnPrice).forEach((c) => {
    const cents = toCents(c.unit_price);
    stemsByPrice.set(cents, (stemsByPrice.get(cents) || 0) + stemsPerBox(c));
  });

  let best = null;
  stemsByPrice.forEach((stems, cents) => {
    if (best === null || stems > best.stems) best = { stems, cents };
  });
  return best === null ? null : best.cents / 100;
};

